import { useIntl } from 'react-intl';
import { useIsDoseShown } from '~/hooks/dose/useDoseVisibility';
import { usePrimaryImageCompletenessGate } from '~/hooks/image/useImageStreamProgress';

/**
 * Why the circle and rectangle, which read image intensity, are refused,
 * localized: when `allowRegions` is false on the dose step (SR-WOR-H-17-5),
 * while a dose is shown, and while the image is not whole (SR-WOR-H-37-3);
 * else undefined.
 */
export function useRegionRefusal(allowRegions: boolean): string | undefined {
    const intl = useIntl();
    const doseShown = useIsDoseShown();
    const imageGate = usePrimaryImageCompletenessGate();
    return !allowRegions
        ? intl.formatMessage({ id: 'intensity.shape.region.notOnDose' })
        : doseShown
          ? intl.formatMessage({
                id: 'intensity.shape.region.notWhileDoseShown',
            })
          : imageGate.reason;
}
